import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { bullrunUseQuery } from "../../hooks/bullrunUseQuery.js";
const BullrunUseQueryContext = createContext(bullrunUseQuery);
export function BullrunUseQueryProvider({ children, useQueryLike }) {
    return _jsx(BullrunUseQueryContext.Provider, { value: useQueryLike, children: children });
}
export function useBullrunUseQuery() {
    return useContext(BullrunUseQueryContext);
}
